import { ListProps, List as MuiList } from "@mui/material";

type Props = ListProps;

export const List = ({ children, ...props }: Props) => {
  return <MuiList {...props}>{children}</MuiList>;
};
